<template>
    <div class="custom-month">
        <div class="items-type">
            <div class="item-type my-cursor"
                 @click.stop="setRepeatType('custom_month')">

                <div class="text-type">按日期</div>
                <div class="img-time-line" :style="{visibility: custom_month.state ? 'visible': 'hidden'}"></div>
            </div>
            <div class="item-type my-cursor"
                 @click.stop="setRepeatType('month_week')">
                <div class="text-type">按星期</div>
                <div class="img-time-line" :style="{visibility: month_week.state ? 'visible': 'hidden'}"></div>
            </div>

        </div>
        <div class="items-day" v-show="custom_month.state">
            <template v-for="(dayItem, dayIndex) in dayItems">
                <div class="item-day my-cursor"
                     :class="{'item-selected': dayItem.state && dayIndex<31 }"
                     :style="{visibility: dayIndex > 31? 'hidden':'visible'}"
                     @click.stop="saveDayItem(dayItem)">

                    <template v-if="dayIndex===31">
                        <div class="item-last" :class="{'item-selected': dayItem.state }">最后一天</div>
                    </template>
                    <template v-else>
                        {{ dayItem.day }}
                    </template>
                </div>
            </template>
        </div>
        <div class="scroll-box" v-show="month_week.state">
            <div class="scroll-number">
                <ScrollModule :items="numberArray" :selected="number" @submitEvent="saveNumber($event)"/>
            </div>
            <div class="scroll-week">
                <ScrollModule :items="weekArray" :selected="week" @submitEvent="saveWeek($event)"/>
            </div>
        </div>
        <div class="skip-state">
            <div class="text-skip">智能跳过法定节假日</div>
            <div class="my-cursor"
                 :class="{
                'icon-switch-false': !skipHolidaysState,
                'icon-switch-true': skipHolidaysState,
            }" @click.stop="saveSkipState">
            </div>
        </div>
    </div>
</template>

<script>
import ScrollModule from "./ScrollModule";
export default {
    name: "RepeatMonth",
    components: {
        ScrollModule
    },
    data(){
        return {
            dayItems: [],
            numberArray: ["第一个", "第二个", "第三个", "第四个", "第五个", "最后一个"],
            number: "第一个",
            weekArray: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日"],
            week: "星期一",
        }
    },
    props: {
        custom_month: {
            type: Object,
            default: {},
        },
        month_week: {
            type: Object,
            default: {},
        },
        skipHolidaysState: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        initCustomMonth: function(){
            let infoArray = [];
            if(this.custom_month.repeatInfo === ""){
                // 选中今天
                infoArray.push(new Date().getDate().toString())
                this.$emit("submitEvent", {repeatType: 'custom_month', repeatCycle: 1, repeatInfo: infoArray[0]});
            }else{
                // 选中
                infoArray = this.custom_month.repeatInfo.split(",")
            }
            this.dayItems.forEach((item)=>{
                item.state = infoArray.indexOf(item.day) > -1
            })

        },
        initMonthWeek: function(){
            if(this.month_week.repeatInfo === ""){
                let  week = new Date().getDay()
                if(week === 0){
                    week = 7
                }
                this.number = "第一个";
                this.week = this.weekArray[week-1];
                const repeatInfo = "1" + week;
                this.$emit("submitEvent", {repeatType: 'month_week', repeatCycle: 1, repeatInfo: repeatInfo});
            }else{
                const repeatInfo = this.month_week.repeatInfo.split("");
                if(repeatInfo[0] === "9"){
                    this.number = "最后一个";
                }else{
                    this.number = this.numberArray[parseInt(repeatInfo[0]) - 1];
                }
                this.week = this.weekArray[parseInt(repeatInfo[1]) - 1];
            }
        },


        setRepeatType: function(repeatType){
            if(this[repeatType].state){
                return
            }else{
                this.$emit("submitTypeEvent");
            }
            if(repeatType === "month_week"){
                this.initCustomMonth();
            }else{
                this.initMonthWeek();
            }

        },
        saveDayItem: function(dayItem){
            dayItem.state = !dayItem.state;
            const textArray = [];
            this.dayItems.forEach((item)=>{
                if(item.state){
                    textArray.push(item.day);
                }
            })
            const repeatInfo = textArray.join(",");
            this.$emit("submitEvent", {repeatType: 'custom_month', repeatCycle: 1, repeatInfo: repeatInfo});
        },
        saveNumber: function(e){
            this.number = e;
            this.submitMonthWeek();
        },
        saveWeek: function(e){
            this.week = e;
            this.submitMonthWeek();
        },
        submitMonthWeek: function(){
            let repeatInfo;
            let numberIndex = this.numberArray.indexOf(this.number);
            let weekIndex = this.weekArray.indexOf(this.week);
            if (numberIndex === 5){
                numberIndex = "9"
            }else{
                numberIndex = (numberIndex + 1).toString()
            }
            weekIndex = (weekIndex + 1).toString();
            repeatInfo = numberIndex + weekIndex;
            this.$emit("submitEvent", {repeatType: 'month_week', repeatCycle: 1, repeatInfo: repeatInfo});
        },
        saveSkipState: function(){
            this.$emit("submitSkipState", !this.skipHolidaysState);
        },
    },
    created(){
        for (let i=1; i<36; i++){
            if(i === 32){
                this.dayItems.push({
                    state: false,
                    day: "99",
                });
            }else{
                this.dayItems.push({
                    state: false,
                    day: i.toString(),
                });
            }

        }
    },
    mounted(){
        if(this.custom_month.state){
            this.initCustomMonth();
        }else{
            this.initMonthWeek();
        }
    },
}
</script>

<style scoped>
div.custom-month{
    width: 100%;
    background: rgba(254,228,148,0.2);
    border-radius: 0.15rem;
    border: 0.02rem solid #FEE494;
    padding: 0.3rem 0.2rem;
    box-sizing: border-box;
    margin-top: 0.2rem;
}
div.items-type{
    width: 100%;
    display: flex;
    gap: 0.2rem;
}
div.text-type{

    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    line-height: 0.2rem;
    text-align: center;
}
div.img-time-line{
    width: 0.64rem;
    height: 0.07rem;
    background: url("../../../assets/images/List/img-time-line.png");
    background-size: cover;
    margin: -0.07rem auto auto;
}
div.items-day{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    column-gap: 0.24rem;
    row-gap: 0.1rem;
    justify-content: space-between;
    margin-top: 0.2rem;
}
div.item-day{
    width: 0.26rem;
    height: 0.26rem;

    font-weight: bold;
    font-size: 0.16rem;
    color: #000000;
    text-align: center;
    line-height: 0.26rem;
    border-radius: 50%;
}
div.item-last{
    width: 0.77rem;
    height: 0.26rem;
    border-radius: 0.05rem;
    border: 0.02rem solid #000000;
    box-sizing: border-box;

    font-weight: bold;
    font-size: 0.14rem;
    color: #000000;
    line-height: 0.22rem;
    text-align: center;
}

div.item-selected{
    color: #FFFFFF;
    background: #000000;
}
div.scroll-box{
    width: 100%;
    margin-top: 0.2rem;

    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.2rem;
}
div.scroll-number, div.scroll-week{
    width: 1rem;
    height: 1.2rem;
    text-align: center;
}

div.skip-state{
    width: 100%;
    height: 0.36rem;
    background: rgba(252, 132, 112, 0.3);
    border-radius: 0.06rem;
    margin-top: 0.2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 0.12rem;
}
div.text-skip{
    font-size: 0.15rem;
    color: #000000;
    text-align: center;
}
div.icon-switch-true, div.icon-switch-false{
    width: 0.5rem;
    height: 0.24rem;
}
div.icon-switch-true{
    background: url("../../../assets/images/List/icon-switch-true.png");
    background-size: cover;
}
div.icon-switch-false{
    background: url("../../../assets/images/List/icon-switch-false.png");
    background-size: cover;
}
</style>